import { Component } from 'react';
import { get, isEqual } from 'lodash/fp';
import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Tab } from '@optimus-web/core';
import { SIMPLE_DETAIL_RESERVATION, SIMPLE_DETAIL_GROUP } from '../module';
import { SmartDetail } from '../../reservationModule/components/SmartDetail';
import { CommanderSidebar } from '../../../components/sidebar';
import { CustomerEntityTitle } from '../../../components/commander-ui/EntityTitle';
import { refreshPage } from '../../app/actions/common';
import { fetchReservationData, fetchReservationGroupData } from '../actions';
import GroupSimpleDetail from './GroupSimpleDetail';
import GroupTabLabel from './GroupTabLabel';

const getId = get('id');
const getGroupId = get('groupId');
const getCustomer = get('customer');

interface OwnProps {
    resourceUse?: {};
    mode?: string;
    handleReservationSelected?: $TSFixMeFunction;
    handleGetReservationGroup?: $TSFixMeFunction;
    handleGetReservation?: $TSFixMeFunction;
    onNavigateToSpaceUse?: (id: string, isReservation: boolean) => void;
    isReservationOverview?: boolean;
}

type Props = OwnProps & typeof ReservationSimpleDetail.defaultProps;

class ReservationSimpleDetail extends Component<Props> {
    static defaultProps = {
        mode: SIMPLE_DETAIL_RESERVATION,
        isReservationOverview: false,
    };

    componentDidMount() {
        // @ts-expect-error $TSFixMeError: Property 'groupId' does not exist on type '{}'.
        this.handleGetReservationGroup(this.props.resourceUse?.groupId);

        // @ts-expect-error $TSFixMeError: Property 'id' does not exist on type '{}'.
        if (this.props.resourceUse?.id) {
            // @ts-expect-error $TSFixMeError: Property 'id' does not exist on type '{}'.
            this.handleGetReservation(this.props.resourceUse.id);
        }
    }

    componentDidUpdate(prevProps: Props) {
        // @ts-expect-error $TSFixMeError: Property 'groupId' does not exist on type '{}'.
        const groupId = this.props.resourceUse?.groupId;
        // @ts-expect-error $TSFixMeError: Property 'id' does not exist on type '{}'.
        const reservationId = this.props.resourceUse?.id;
        if (groupId && groupId !== (prevProps.resourceUse as $TSFixMe)?.groupId) {
            this.handleGetReservationGroup(groupId);
        }

        if (reservationId && reservationId !== (prevProps.resourceUse as $TSFixMe)?.id) {
            this.handleGetReservation(reservationId);
        }
    }

    // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
    handleGetReservationGroup = (groupId: $TSFixMe) => groupId && this.props.handleGetReservationGroup(groupId);

    handleGetReservation = (reservationId: $TSFixMe) =>
        // @ts-expect-error $TSFixMeError: Cannot invoke an object which is possibly 'undefined'.
        reservationId ? this.props.handleGetReservation(reservationId) : Promise.resolve();

    render() {
        const {
            resourceUse,
            mode,
            handleReservationSelected,
            isReservationOverview,
            // @ts-expect-error $TSFixMeError: Property 'handleReloadCurrentModal' does not exist on type 'Readonly<Props> & Readonly<{ children?: ReactNode; }>'.
            handleReloadCurrentModal,
        } = this.props;
        if (!resourceUse) {
            return null;
        }

        // @ts-expect-error $TSFixMeError: Property 'id' does not exist on type '{}'.
        const { id, groupId } = resourceUse;

        if (mode === SIMPLE_DETAIL_RESERVATION) {
            const handleUpdate = () => {
                const promise = this.handleGetReservation(id);
                return isReservationOverview ? promise.then(handleReloadCurrentModal) : promise;
            };
            return <SmartDetail reservationId={id} onUpdate={handleUpdate} />;
        }

        return (
            <GroupSimpleDetail
                groupId={groupId}
                // @ts-expect-error $TSFixMeError: Type '{ groupId: any; handleReservationSelected: $TSFixMeFunction | undefined; selectedReservationId: any; onNavigateToS...
                handleReservationSelected={handleReservationSelected}
                selectedReservationId={id}
                onNavigateTo={this.props.onNavigateToSpaceUse}
            />
        );
    }
}

export default connect(
    undefined,
    (
        dispatch,
        // @ts-expect-error $TSFixMeError: Property 'resourceUse' does not exist on type '{}'.
        { resourceUse, withGroupDetail, showReservation, showGroup, mode = SIMPLE_DETAIL_RESERVATION, scope, ...props }
    ) => {
        const tabScenario = {
            [SIMPLE_DETAIL_RESERVATION]: {
                action: showReservation,
                getter: getId,
            },
            [SIMPLE_DETAIL_GROUP]: {
                action: showGroup,
                getter: getGroupId,
            },
        };
        const handleTabClick = (e: $TSFixMe, value: $TSFixMe) => {
            // @ts-expect-error $TSFixMeError: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ simpleDetailReserva...
            const { action, getter } = tabScenario[value];
            return action(getter(resourceUse), scope);
        };

        const groupId = resourceUse?.groupId;

        return {
            // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
            handleGetReservationGroup: (groupIdProp: $TSFixMe) => dispatch(fetchReservationGroupData(groupIdProp)),
            // @ts-expect-error $TSFixMeError: Argument of type '(dispatch: $TSFixMe, getState: $TSFixMe) => any' is not assignable to parameter of type 'Action<any>'.
            handleGetReservation: (reservationId: $TSFixMe) => dispatch(fetchReservationData(reservationId)),
            // @ts-expect-error $TSFixMeError: Argument of type 'ThunkAction<Action<any>, void, ApplicationState>' is not assignable to parameter of type 'Action<any>'...
            handleReloadCurrentModal: () => dispatch(refreshPage({ keepScrollPosition: true })),
            title: <CustomerEntityTitle {...getCustomer(resourceUse)} />,
            withContentSpacing: mode !== SIMPLE_DETAIL_RESERVATION,
            tabsConfig: withGroupDetail
                ? {
                      activeTabValue: mode,
                      handleTabClick,
                      inline: true,
                      tabs: [
                          <Tab
                              id={`${scope}-reservation`}
                              label={<LocalizedText textKey={TextKey.Reservation} />}
                              value={SIMPLE_DETAIL_RESERVATION}
                          />,
                          <Tab
                              id={`${scope}-group`}
                              label={<GroupTabLabel groupId={groupId} />}
                              value={SIMPLE_DETAIL_GROUP}
                          />,
                      ],
                  }
                : null,
            ...props,
        };
    },
    null,
    {
        areStatesEqual: isEqual,
    }
    // @ts-expect-error https://mews.myjetbrains.com/youtrack/issue/kanban-4230/Types-for-Commander-Sidebar
)(CommanderSidebar(ReservationSimpleDetail));
